
import recipientMessages from './recipientMessages';
import { recipientStepPostConditions, recipientStepPreConditions } from './recipientStepSelectors';
import { catalogsAreLoaded } from '../catalogs/catalogSelectors';
import {
    hasDigital as hasDigitalFaceplates,
    hasPlastic as hasPlasticFaceplates
} from '../faceplate/faceplateSelectors';

const recipientStepConfig = {
    component: () => import('./RecipientStep'),
    flow: 'buy',
    isReady: (state) => {
        const catalogLoaded = catalogsAreLoaded(state);
        const hasElect = hasDigitalFaceplates(state);
        const hasPlastic = hasPlasticFaceplates(state);
        return catalogLoaded && (hasElect || hasPlastic);
    },
    preConditions: recipientStepPreConditions,
    postConditions: recipientStepPostConditions,
    getSubmitMessage: () => recipientMessages.submitButtonText,
    canSkip: null 
};

export default recipientStepConfig;
